import { Action } from 'redux';

import { REQUEST_API } from 'src/constants';
import {
  CANCEL_MULTINARRATIVE_ACTION,
  CANCEL_MULTINARRATIVE_ACTION_SUCCESS,
  COMMENT_REPLY_REQUEST_API,
  COMMENT_REQUEST_API,
  FORCE_UNLOCK_MULTINARRATIVE_ACTION,
  GET_PUBLICATION_LIST_REQUEST,
  LOCK_MULTINARRATIVE_ACTION,
  LOCK_MULTINARRATIVE_ACTION_SUCCESS,
  RECEIVE_DATA_NOTES_FROM_API,
  RECEIVE_EXTRA_NARRATIVE_FROM_API,
  RECEIVE_MULTI_NARRATIVE_FROM_API,
  RECEIVE_MULTI_NARRATIVE_SINGLE_FROM_API,
  RECEIVE_NARRATIVE_FROM_API,
  REQUEST_API_LATEST,
  RESET_MULTINARRATIVE_ACTION,
  RESET_REPORTS_LIST,
  RESTORE_COMMENT_REQUEST_API,
  RESTORE_VERSION_MULTINARRATIVE_ACTION,
  RESTORE_VERSION_MULTINARRATIVE_ACTION_SUCCESS,
  SAVE_MULTINARRATIVE_ACTION,
  SAVE_MULTINARRATIVE_ACTION_FAILED,
  SAVE_MULTINARRATIVE_ACTION_SUCCESS,
  SET_EXTRA_NARRATIVE_ACTION,
  SET_NARRATIVE_ACTION,
  SET_SUBTITLE_ACTION,
  SET_SUBTITLE_SUCCESS_ACTION,
} from './actions';

export const CLEAR_API_KEYS = 'CLEAR_API_KEYS';

export interface GetPublicationListRequest {
  period: string;
}

export interface GetPublicationListRequestAction {
  payload: GetPublicationListRequest;
  type: typeof GET_PUBLICATION_LIST_REQUEST;
}

export interface ReceiveDataNotesResponseAction {
  type: typeof RECEIVE_DATA_NOTES_FROM_API;
  dataKey: string;
  payload: any;
  request_params: any;
}

export interface ReceiveDataNotesPayload {
  data_notes: string;
}

export interface SetSubtitleValRequest {
  sectionId: number;
  val: string;
}
export interface SetSubtitleValRequestAction {
  type: typeof SET_SUBTITLE_ACTION;
  value: string;
  sectionId: number;
}
export interface SetSubtitleValSuccess {
  value: string;
}
export interface SetSubtitleValSuccessAction {
  type: typeof SET_SUBTITLE_SUCCESS_ACTION;
  value: string;
}

export interface LockMultiNarrative {
  narrativeId: number;
  reportId: number;
}

export interface LockMultiNarrativeAction extends LockMultiNarrative {
  type: typeof LOCK_MULTINARRATIVE_ACTION;
}

export interface LockMultiNarrativeSuccess {
  narrativeId: number;
  editor: string;
  content?: string;
}
export interface LockMultiNarrativeSuccessAction
  extends LockMultiNarrativeSuccess {
  type: typeof LOCK_MULTINARRATIVE_ACTION_SUCCESS;
}

export interface SaveMultiNarrative {
  autoSave: boolean;
  content: string;
  narrativeId: number;
  wordCount: number;
  reportId?: number;
}

export interface SaveMultiNarrativeAction extends SaveMultiNarrative {
  type: typeof SAVE_MULTINARRATIVE_ACTION;
}

export interface SaveMultiNarrativeSuccess {
  autosave: boolean;
  value: INarrativeVal;
}

export interface SaveMultiNarrativeSuccessAction
  extends SaveMultiNarrativeSuccess {
  type: typeof SAVE_MULTINARRATIVE_ACTION_SUCCESS;
}

export interface SaveMultiNarrativeFailedAction {
  type: typeof SAVE_MULTINARRATIVE_ACTION_FAILED;
}

interface INarrativeVal {
  id: number;
  content: string;
  title: string;
  order: number;
  limit: number;
  editor: string;
  is_optional: boolean;
  show_title: boolean;
  i_am_editor: boolean;
  locked_at: string;
  info: string;
}

export interface CancelMultiNarrative {
  narrativeId: number;
  reportId: number;
}

export interface CancelMultiNarrativeAction extends CancelMultiNarrative {
  type: typeof CANCEL_MULTINARRATIVE_ACTION;
}

export interface CancelMultiNarrativeSuccess {
  value: INarrativeVal;
}

export interface CancelMultiNarrativeSuccessAction
  extends CancelMultiNarrativeSuccess {
  type: typeof CANCEL_MULTINARRATIVE_ACTION_SUCCESS;
}

export interface ResetMultiNarrative {
  narrativeId: number;
}
export interface ResetMultiNarrativeAction extends ResetMultiNarrative {
  type: typeof RESET_MULTINARRATIVE_ACTION;
}

export interface RestoreVersionMultiNarrative {
  narrativeVersionId: number;
  content: string;
  narrativeId: number;
}
export interface RestoreVersionMultiNarrativeAction
  extends RestoreVersionMultiNarrative {
  type: typeof RESTORE_VERSION_MULTINARRATIVE_ACTION;
}

export interface RestoreVersionMultiNarrativeSuccess {
  content: string;
  narrativeId: number;
}
export interface RestoreVersionMultiNarrativeSuccessAction
  extends RestoreVersionMultiNarrativeSuccess {
  type: typeof RESTORE_VERSION_MULTINARRATIVE_ACTION_SUCCESS;
}

export interface ForceUnlockMultiNarrative {
  narrativeId: number;
  reportId: number;
}
export interface ForceUnlockMultiNarrativeAction
  extends ForceUnlockMultiNarrative {
  type: typeof FORCE_UNLOCK_MULTINARRATIVE_ACTION;
}

export interface ReceiveMultiNarrativeSingleResponse {
  content: string;
  editor: string;
  narrative_id: number;
  title: string;
}
export interface ReceiveMultiNarrativeSingleResponseAction {
  type: typeof RECEIVE_MULTI_NARRATIVE_SINGLE_FROM_API;
  payload: ReceiveMultiNarrativeSingleResponse;
}

export interface SetNarrativeVal {
  val: string;
}
export interface SetNarrativeValAction {
  value: string;
  type: typeof SET_NARRATIVE_ACTION;
}

export interface SetExtraNarrativeVal {
  val: string;
  id: number;
}

export interface SetExtraNarrativeValAction {
  type: typeof SET_EXTRA_NARRATIVE_ACTION;
  value: string;
  id: number;
}

export type ReceiveExtraNarrativeResponse = IExtraNarrativeResponse[];

interface IExtraNarrativeResponse {
  content: string;
  id: number;
  title: string;
}
export interface ReceiveExtraNarrativeResponseAction {
  payload: ReceiveExtraNarrativeResponse;
  type: typeof RECEIVE_EXTRA_NARRATIVE_FROM_API;
}

export interface ReceiveNarrativeResponseAction {
  payload: string;
  type: typeof RECEIVE_NARRATIVE_FROM_API;
}

export type ReceiveMultiNarrativeResponse = INarrativeVal[];

export interface ReceiveMultiNarrativeResponseAction {
  payload: ReceiveMultiNarrativeResponse;
  type: typeof RECEIVE_MULTI_NARRATIVE_FROM_API;
}

export interface ResetReportsListAction {
  type: typeof RESET_REPORTS_LIST;
}

export interface ClearApiKeysAction {
  type: typeof CLEAR_API_KEYS;
  dataKeys: string[];
}

export interface IRequestParams {
  data?: any;
  method?: string;
  url_format?: UrlFormatParams;
  storage_key?: string;
  success_actions?: Action[];
}

interface UrlFormatParams {
  _office_?: string;
  _report_?: string;
  _section_?: string;
  _period_?: string;
  _id_?: string | number;
  _year_?: string | number;
  _cpb_key_?: string;
  _type_?: string;
  _comment_?: string;
  _reply_?: string;
}

export interface RequestAPIPayload {
  dataKey: string;
  params: IRequestParams;
}
export interface RequestAPIAction extends RequestAPIPayload {
  type: typeof REQUEST_API;
}

interface ICommentDataPayload {
  content?: string;
  title?: string;
  edit?: boolean;
}

export interface CommentRequestAPIPayload {
  url_format: UrlFormatParams;
  data: ICommentDataPayload;
  method: string;
  storage_key: string;
  reportId: number;
  refreshNarrative: 'main' | 'extra' | 'multi';
}

export interface CommentRequestAPIAction {
  type: typeof COMMENT_REQUEST_API;
  params: CommentRequestAPIPayload;
}

export interface ReplyCommentRequestAPIPayload {
  url_format: UrlFormatParams;
  data: ICommentDataPayload;
  method: string;
  storage_key: string;
}
export interface ReplyCommentRequestAPIAction {
  type: typeof COMMENT_REPLY_REQUEST_API;
  params: ReplyCommentRequestAPIPayload;
}

export interface CommentRestoreRequestAPIPayload {
  url_format: UrlFormatParams;
  data: { comment_id: number };
}

export interface CommentRestoreRequestAPIAction {
  type: typeof RESTORE_COMMENT_REQUEST_API;
  params: CommentRestoreRequestAPIPayload;
}

export interface RequestAPILatestParams {
  url_format: UrlFormatParams;
}
export interface RequestAPILatestAction {
  type: typeof REQUEST_API_LATEST;
  dataKey: string;
  params: RequestAPILatestParams;
}
